<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  viewBox="0 0 160 600" :height="t_output_height" :width="t_output_width">
    <path id="BACKGROUND" fill="#46196e" d="M0 0h160v600H0z" />
    <image xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPIAAAA1CAYAAAB7hbaoAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAt0lEQVR4Xu3TsRHAIBDAsCf77wwj0AafVLv1mpk9wNO+WwD8n5EhwMgQYGQIMDIEGBkCjAwBRoYAI0OAkSHAyBBgZAgwMgQYGQKMDAFGhgAjQ4CRIcDIEGBkCDAyBBgZAowMAUaGACNDgJEhwMgQYGQIMDIEGBkCjAwBRoYAI0OAkSHAyBBgZAgwMgQYGQKMDAFGhgAjQ4CRIcDIEGBkCDAyBBgZAowMAUaGACNDgJEhwMgQYGQIOC+zAWkGTWZ8AAAAAElFTkSuQmCC" id="Rectangle_1_Image" width="242" height="53" data-name="Rectangle 1 Image" transform="matrix(.5 0 0 .5 19.5 496)" />
    <text fill="#fff" font-family="Tele-Grotesk Next-Ultra" font-size="16" font-weight="800" transform="translate(33.91 514.67)">
      Participa aquí
    </text>
    <text  y="45" width="83" font-family="Tele-Grotesk Next-Ultra" font-size="18" font-weight="800" letter-spacing="-.02em" fill="#fff">
      <tspan dy="1em" x="30" v-for="(word) in verticalStacked" :key="word.id">
        {{ word.word }}
      </tspan>
    </text>
    <text
      text-anchor="middle" data-name="LEGAL" transform="translate(0 535)"
      style="font-size:7.5px;fill:#fff;font-family:Tele-Grotesk Next-Medium;font-weight:500"
    >
      <tspan  x="50%" dy="1em" v-for="(line) in templateLegalArr" :key="line.id">
        {{ line }}
      </tspan>
    </text>
    <path fill="#fff" d="M20 31.91a2.16 2.16 0 0 1-2.31 2.32h-1.18v2.36h-1.42v-7h2.61a2.16 2.16 0 0 1 2.3 2.32Zm-1.47 0a.92.92 0 0 0-.94-1h-1.08v2h1.09a.92.92 0 0 0 .94-1ZM24.23 35.23H21.8l-.45 1.36h-1.44l2.39-7h1.42l2.39 7h-1.43Zm-.44-1.31L23 31.64l-.75 2.28ZM30.33 36.59 29 34h-.68v2.56H26.9v-7h2.6a2.13 2.13 0 0 1 2.33 2.23 2.05 2.05 0 0 1-1.41 2.08l1.48 2.7Zm-2-3.88h1.11a.91.91 0 1 0 0-1.82h-1.12ZM32.48 29.58h5v1.31H35.7v5.7h-1.42v-5.7h-1.8ZM38.34 29.58h1.41v7h-1.41ZM43.82 29.41a2.61 2.61 0 0 1 2.67 2.4H45a1.17 1.17 0 0 0-1.19-1c-1 0-1.5.8-1.5 2.31s.53 2.31 1.5 2.31a1.18 1.18 0 0 0 1.19-1h1.48a2.61 2.61 0 0 1-2.67 2.39c-1.9 0-3-1.41-3-3.67s1.11-3.74 3.01-3.74ZM47.47 29.58h1.41v7h-1.41ZM55.17 31.91a2.16 2.16 0 0 1-2.31 2.32h-1.2v2.36h-1.42v-7h2.62a2.16 2.16 0 0 1 2.31 2.32Zm-1.47 0a.92.92 0 0 0-1-1h-1.04v2h1.09a.92.92 0 0 0 .95-1ZM59.38 35.23H57l-.45 1.36h-1.49l2.4-7h1.41l2.4 7h-1.44ZM59 33.92l-.76-2.28h-.06l-.75 2.28ZM67 33.73v2.86h-1.44v-2.86l-2.25-4.15H65l1.27 2.58h.07l1.28-2.58h1.66ZM76.82 31.91a2.16 2.16 0 0 1-2.31 2.32h-1.2v2.36h-1.42v-7h2.62a2.16 2.16 0 0 1 2.31 2.32Zm-1.47 0a.92.92 0 0 0-.95-1h-1.09v2h1.09a.92.92 0 0 0 .95-1ZM77.53 33.09c0-2.27 1-3.68 3-3.68s3 1.41 3 3.68-1 3.67-3 3.67-3-1.4-3-3.67Zm4.47 0c0-1.53-.52-2.31-1.5-2.31s-1.5.78-1.5 2.31.53 2.31 1.5 2.31 1.5-.78 1.5-2.31ZM84.58 29.58H87c1.83 0 3 1.23 3 3.51s-1.14 3.5-3 3.5h-2.42Zm2.33 5.7c1 0 1.6-.65 1.6-2.19s-.63-2.2-1.6-2.2H86v4.39ZM94.49 36.59 93.17 34h-.69v2.56h-1.41v-7h2.59A2.13 2.13 0 0 1 96 31.81a2.05 2.05 0 0 1-1.41 2.08l1.48 2.7Zm-2-3.88h1.11a.91.91 0 1 0 0-1.82h-1.12ZM98 27.4h1.34l-1 1.48H97Zm-.89 2.18h1.42v7h-1.47ZM103.57 35.23h-2.43l-.45 1.36h-1.44l2.4-7h1.41l2.4 7H104Zm-.43-1.31-.76-2.28h-.06l-.75 2.28ZM105.81 34.61h1.41a1 1 0 0 0 1 .82c.6 0 .9-.34.9-.79s-.29-.68-.84-.83l-.81-.23a2 2 0 0 1-1.56-2 2.32 2.32 0 0 1 4.62-.08h-1.39a.84.84 0 0 0-.93-.78.77.77 0 0 0-.85.76c0 .48.32.65.71.76l.81.22a2.09 2.09 0 0 1 1.69 2.07 2.16 2.16 0 0 1-2.35 2.2 2.2 2.2 0 0 1-2.41-2.12ZM119.13 32.9v.39c0 2.32-1 3.47-2.82 3.47-2 0-3.06-1.43-3.06-3.67s1.09-3.68 3-3.68a2.6 2.6 0 0 1 2.75 2.23h-1.51a1.21 1.21 0 0 0-1.23-.86c-1 0-1.55.8-1.55 2.31s.53 2.31 1.58 2.31a1.26 1.26 0 0 0 1.37-1.28h-1.26V32.9ZM123.73 35.23h-2.43l-.45 1.36h-1.44l2.4-7h1.41l2.4 7h-1.44Zm-.43-1.31-.76-2.28h-.06l-.75 2.28ZM131.83 29.58v7h-1.43l-2.51-4.38h-.07v4.38h-1.41v-7h1.43l2.52 4.42h.07v-4.42ZM136.94 35.23h-2.43l-.45 1.36h-1.44l2.4-7h1.41l2.4 7h-1.44Zm-.43-1.31-.76-2.28h-.06l-.75 2.28ZM143 36.59 141.72 34H141v2.56h-1.42v-7h2.59a2.13 2.13 0 0 1 2.33 2.23 2.05 2.05 0 0 1-1.41 2.08l1.48 2.7Zm-2-3.88h1.11a.91.91 0 1 0 0-1.82H141Z" transform="translate(-.01 -.25)" />
    <image x="0" y="204" width="160" height="224" :href="selectedImage"></image>
    <image x="22" y="451" width="115" height="40" href="@/assets/metro-logo-tight--white.png"></image>
  </svg>
</template>

<script>
export default {
  name: 'METROSP160x600ES',
  props: {
    selectedImage: {
      type: String,
      default: ''
    },
    templateAbbrPrizeDescription: {
      type: String,
      default: ''
    },
    templateAbbrLegal: {
      type: String,
      default: ''
    },
    t_output_height: {
      type: [Number, String],
      default: 600
    },
    t_output_width: {
      type: [Number, String],
      default: 160
    },
    templateLegalArr: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  computed: {
    verticalStacked() {
      return this.templateAbbrPrizeDescription.split(' ').map((word, index) => {
        return {
          word: word,
          y: index * 66.87
        };
      });
    }
  }
};
</script>
